import React, { useEffect, useState } from "react";
import { makeStyles, InputLabel, TextField } from '@material-ui/core';
import { Tag } from "src/app-components/Tag";

const useStyles = makeStyles((theme) => ({
    label: {
        marginBottom: '12px'
    }
}));

export default function InputMultiEmail(props) {
    const classes = useStyles();
    const [email, setEmail] = useState('');
    const [emailList, setEmailList] = useState([]);
    const [emailListHasError, setEmailListHasError] = useState(false);
    const [emailListErrorText, setEmailListErrorText] = useState('');

    useEffect(() => {
        setEmailList(props.value);
    }, [props.value]);

    const isEmailValid = () => {
        const emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailRegEx.test(String(email).toLowerCase());
    }

    const onEmailListChange = () => {
        setEmailListHasError(false);
        setEmailListErrorText('');

        if (!isEmailValid()) {
            setEmailListHasError(true);
            setEmailListErrorText('Invalid email');
        } else if (emailList.includes(email.toLowerCase())) {
            setEmailListHasError(true);
            setEmailListErrorText('Email already exists');
        } else {
            submitEmailList();
        }
    };

    const addEmailOnBlur = () => {
        if(email && isEmailValid() && !emailList.includes(email.toLowerCase())){
            submitEmailList();
        }
    }

    const submitEmailList = () => {
        let emailListCopy = JSON.parse(JSON.stringify(emailList));
        emailListCopy.push(email.toLowerCase());
        setEmail("");
        props.onChange(emailListCopy);
    }

    const removeEmail = (idx) => {
        let emailListCopy = JSON.parse(JSON.stringify(emailList));
        emailListCopy.splice(idx, 1);
        setEmailList(emailListCopy);
        props.onChange(emailListCopy);
    }

    return (
        <>
            {props.label ? <InputLabel htmlFor={props.id} className={classes.label}>{props.label}</InputLabel> : null}
            <TextField
                type="text"
                fullWidth
                id={props.id}
                value={email}
                onChange={(e) => { setEmail(e.target.value) }}
                onKeyPress={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        onEmailListChange();
                    }
                }}
                onBlur={(e) => {
                    e.preventDefault();
                    addEmailOnBlur();
                }}
                variant="outlined"
                error={emailListHasError}
                helperText={emailListErrorText}
            />
            <div css="margin-top: 10px;">
                {
                    emailList.length ?
                        emailList.map((item, idx) => (
                            <Tag
                                key={idx}
                                name={item}
                                deletable={true}
                                onDelete={() => removeEmail(idx)}
                            />
                        ))
                        : null
                }
            </div>
        </>
    )
}